(function($){
    if($('body').hasClass('show-omnibus')) {
        if ($('input[name="product_id"]').length >= 0) {
            var prod_id;
            if ($('input[name="product_id"]').length > 0) {
                prod_id = $('input[name="product_id"]').val();
            } else {
                prod_id = $('button.single_add_to_cart_button').val();
            }
            load_legia_omnibus(prod_id);
        }
        $('input.variation_id').change(function () {
            if ('' != $(this).val()) {
                var prod_id = $(this).val();
                load_legia_omnibus(prod_id);
            }
        });
    }
    function load_legia_omnibus(val) {
        $.ajax({
            url: script.ajax_url,
            method: 'post',
            data: {
                'action': 'load_legia_omnibus',
                'val': val,
                'nonce': script.nonce
            },
            beforeSend: function beforeSend() {
                $('.legia-omnibus').remove();
                $('.entry-summary form.cart').append('<div class="legia-omnibus"><img src="' + $('body').attr('data-loader') + '" class="search-loader" /></div>');
            },
            success: function success(data) {
                console.log(data);
                try {
                    var resp = JSON.parse(data);

                    if (resp['status'] == 'exists') {
                        $('.legia-omnibus').html('<div class="legia-omnibus">'+resp['string']+'</div>');
                    }
                    else{
                        $('.legia-omnibus').remove();
                    }
                } catch (e) {
                    // alert();
                }
                // $('.search-loader').remove();
                // $('.ajax-result').remove();
                // $('header [role="search"]').append(data);
            },
            error: function error(errorThrown) {
                console.log(errorThrown);
            }
        });
    }

})(jQuery)